const context = require.context('./en', false, /\.js$/)
const messages = {}

context.keys().forEach((key) => {
  const moduleName = key.replace(/^\.\/(.*)\.js$/, '$1')
  const moduleContent = context(key).default
  // 如果是 element.js，直接合并其内容（el）
  if (moduleName === 'element') {
    Object.assign(messages, moduleContent)
  } else {
    messages[moduleName] = moduleContent
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js